import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { GlobalConstants } from 'src/app/services/global-constants';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { ConfirmationService } from 'primeng/api';
import { DataService } from 'src/app/services/data.service';
import { PermissionHandlerService } from 'src/app/services/permission-handler.service';
import { TranslatorPipe } from 'src/app/services/translator.pipe';

@Component({
  selector: 'app-training-rating',
  templateUrl: './training-rating.component.html',
  styleUrl: './training-rating.component.scss'
})
export class TrainingRatingComponent {
  //Data Variables
  @Input() courseId: string = '';
  @Input() isUser: boolean = false;
  @Input() isMainTrainer: boolean = false;
  courseData: any
  courseUsers: any
  courseTrainers: any
  courseRating: any
  CurrTab: string = 'User';
  isSkelition: boolean = false


  constructor(
    private dataService: DataService,
    private router: Router,
    private route: ActivatedRoute,
    private confirmationService: ConfirmationService,
    public permissionService: PermissionHandlerService,
  ) { }

  ngOnInit() {
    this.isSkelition = true;
    this.getCourseData().then(() => {
      this.getCourseRating(this.courseId).then(() => {
        this.isSkelition = false;
      });
    });
  }

  ngOnChanges(simpleChange: SimpleChanges) {
    this.isSkelition = true;
    this.getCourseData().then(() => {
      this.getCourseRating(this.courseId).then(() => {
        this.isSkelition = false;
      });
    });
  }


  async getCourseData() {
    if (this.courseId) {
      try {
        const res = await this.dataService.getData(`course/id/${this.courseId}`);
        if (res.error) {
          console.log(res.msg);
          return;
        }
        this.courseData = res.data[0];
        this.courseRating = this.courseData?.training_request?.ratingSettings;
      } catch (e: any) {
        console.log(e)
      }
    }
  }

  async getCourseRating(id: any) {
    let res = await this.dataService.getData('course/trainer-rating/' + id)
    if (res.error) {
      return
    }
    this.courseTrainers = res.data.trainers;
    this.courseUsers = res.data.users;
  }

  async updateAttempt(ratings: any[], user_id: string) {
    try {
      this.isSkelition = true;
      let email = localStorage.getItem('email') || '';
      let rating = this.getCurrentUserRating(ratings, email, user_id)
      if (rating) {
        let data: any = {
          _id: rating._id,
          ratingSubmitted: true
        }
        let res = await this.dataService.postData('survey-attempt', data, 'PUT')
        if (!res.error) {
          this.ngOnInit()
        }
      }

    } catch (e) {
      console.log(e)
    }
  }

  getName(name: any) {
    return Object.values(name).join(' ');
  }

  openAttempt(user_id: string) {
      let url, id;
      let queryParams: any = { courseId: this.courseId };
      url = `/sa/survey/attempt`

      if (this.isUser) {
          id = this.courseRating.surveryIdUsers;
          queryParams['ratingFor'] = 'Trainer';
          queryParams['ratingForID'] = user_id;
      } else {
          id = this.courseRating.surveryIdTrainers;
          queryParams['ratingFor'] = 'User';
          queryParams['ratingForID'] = user_id;
      }

      queryParams['isMainTrainer'] = this.isMainTrainer;
      if (this.isMainTrainer) {
          queryParams['ratingFor'] = this.CurrTab;
      }

      if (url && id) {
          const queryString = new URLSearchParams(queryParams).toString();
          const fullUrl = `${url}/${id}?${queryString}`;
          window.open(fullUrl, '_blank');
      }
  }


  checkSurveyAttempt(ratings: any[], user_id: string) {
    let email = localStorage.getItem('email');
    return !(ratings.some((rating: any) => rating.email == email && rating.ratingForID == user_id));
  }

  getCurrentUserRating(ratings: any[], email: string, user_id: string): any | undefined {
    return ratings.find((rating: any) => rating.email == email && rating.ratingForID == user_id);
  }

  checkRatingSubmitted(ratings: any[], user_id: string): any | undefined {
    let email = localStorage.getItem('email');
    let rating = ratings.find((rating: any) => rating.email == email && rating.ratingForID == user_id);
    if (rating) {
      return (rating.ratingSubmitted == true) ? false : true
    }
    else {
      return false;
    }
  }

  ChangeTab(tab: any, event: any) {
    this.CurrTab = tab;
    this.isUser = (tab == 'User') ? false : true;
  }
}
